enum TransactionIdentifierDisplayType {
  SHOW = "SHOW", // display transaction identifier directly
  TOOLTIP = "TOOLTIP", // display transaction identifier as tooltip
  HIDE = "HIDE" // hide transaction identifier
}

export default TransactionIdentifierDisplayType;
